import Reflux, { RefluxAction } from "reflux";

const CustomerAddAddressAction: RefluxAction<any> = Reflux.createAction({
    asyncResult: true
});

export default CustomerAddAddressAction;
